<template>
  <header class="header">
    <div class="header-top">
      <div class="container">
        <div class="header-left">
          <img :src="logoImg" alt="云南省妇幼保健院" class="logo-img" />
        </div>
        <div class="header-center">
          <div class="search-box">
            <input type="text" placeholder="请输入关键字" class="search-input" v-model="searchKeyword" />
            <button class="search-btn" @click="handleSearch">全站搜索</button>
          </div>
        </div>
        <div class="header-right">
          <div class="social-icons">
            <img :src="mtImg" alt="社交媒体" class="social-img" />
          </div>
        </div>
      </div>
    </div>
    <nav class="nav-bar">
      <div class="container">
        <ul class="nav-list">
          <li class="nav-item" v-for="item in navItems" :key="item.name" :class="{ active: activeNav === item.name }">
            <router-link 
              :to="item.category ? { path: item.path, query: { category: item.category } } : item.path" 
              @click.native="activeNav = item.name"
            >
              {{ item.label }}
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import axios from 'axios'
import logoImg from '@/assets/images/logo.png'
import mtImg from '@/assets/images/mt.png'

export default {
  name: 'AppHeader',
  data() {
    return {
      searchKeyword: '',
      activeNav: '医院概况',
      flatCategories: [],
      logoImg,
      mtImg
    }
  },
  computed: {
    navItems() {
      const catMap = {}
      this.flatCategories.forEach(cat => {
        if (cat.name) {
          catMap[cat.name] = cat.id
        }
      })
      
      return [
        { name: '首页', label: '首页', path: '/' },
        { name: '医院概况', label: '医院概况', path: '/about' },
        { name: '科室介绍', label: '科室介绍', path: '/departments' },
        { name: '专家介绍', label: '专家介绍', path: '/doctors' },
        { name: '就医指南', label: '就医指南', path: '/medical-guide' },
        { name: '健康教育', label: '健康教育', path: '/articles', category: catMap['健康教育'] || 3 },
        { name: '科研教学', label: '科研教学', path: '/articles', category: catMap['科研教学'] || 4 },
        { name: '医院文化', label: '医院文化', path: '/articles', category: catMap['医院文化'] || 7 },
        { name: '党群工作', label: '党群工作', path: '/articles', category: catMap['党群工作'] || 5 },
        { name: '妇幼视频', label: '妇幼视频', path: '/maternal-videos' },
        { name: '下载专区', label: '下载专区', path: '/downloads' },
        { name: '基层天地', label: '基层天地', path: '/articles', category: catMap['基层天地'] || 45 },
        { name: '信息公开', label: '信息公开', path: '/articles', category: catMap['预决算公开'] || 8 }
      ]
    }
  },
  mounted() {
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/api/categories')
        if (response.data && response.data.flat) {
          this.flatCategories = response.data.flat
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('请输入搜索关键字')
        return
      }
      this.$router.push(`/articles?keyword=${encodeURIComponent(this.searchKeyword)}`)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 200;
  
  .header-top {
      background: #ffffff;
      padding: 20px 0;

      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    .header-left {
      flex: 0 0 auto;
      
      .logo-img {
        height: 90px;
        object-fit: contain;
      }
    }

    .header-center {
      flex: 1;
      display: flex;
      justify-content: center;
      
      .search-box {
        display: flex;
        background: white;
        border: 1px solid #ddd;
        border-radius: 25px;
        overflow: hidden;

        .search-input {
          width: 260px;
          height: 38px;
          border: none;
          padding: 0 20px;
          font-size: 14px;
          outline: none;
        }

        .search-btn {
          width: 85px;
          height: 38px;
          background: #00aeaa;
          color: white;
          border: none;
          font-size: 14px;
          cursor: pointer;

          &:hover {
            background: #00aeaa;
          }
        }
      }
    }

    .header-right {
      flex: 0 0 auto;
      display: flex;
      gap: 20px;
      align-items: center;
      margin-left: auto;
      
      .social-icons {
        display: flex;
        align-items: center;
        
        .social-img {
          height: 112.5px;
          width: auto;
          object-fit: contain;
        }
      }
    }
  }

  .nav-bar {
    background: #00aeaa;
    border-top: 1px solid #00aeaa;
    border-bottom: 1px solid #00aeaa;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .nav-list {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      flex-wrap: nowrap;
      white-space: nowrap;

      .nav-item {
        padding: 15px 12px;

        a {
          text-decoration: none;
          color: #fff;
          font-size: 15px;
          font-weight: 500;
          transition: color 0.3s;
          white-space: nowrap;

          &:hover {
            color: #fff;
          }
        }

        &.active a {
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
